import { CalendarDays } from "lucide-react";
import { NEWS } from "@/data/church";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const TAG_STYLES = {
  Services: "bg-[#0F766E] text-[#FBF6EC]",
  Community: "bg-[#047857] text-[#FBF6EC]",
  Notices: "bg-[#D97706] text-[#101826]",
};

export default function News() {
  return (
    <>
      <PageHero
        testId="news-hero"
        kicker="News & Notices"
        title="From the Church Family"
        lead="Announcements and service updates — written plainly and kept up to date."
      />

      <section data-testid="news-list-section" className="bg-gradient-to-b from-[#581C87] to-[#A61C4E] py-16 sm:py-24">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <div className="flex flex-col gap-6">
            {NEWS.map((item, i) => (
              <Reveal key={item.id} delay={i * 0.06}>
                <article
                  data-testid={`news-card-${item.id}`}
                  className="rounded-2xl border-2 border-[#C59B4B]/50 bg-[#FFFDF8] p-8 shadow-lg transition-all duration-300 hover:border-[#F2C14E] hover:shadow-xl sm:p-10"
                >
                  <div className="flex flex-wrap items-center gap-3">
                    <span
                      className={`rounded-full px-4 py-1.5 text-sm font-semibold ${TAG_STYLES[item.tag]}`}
                    >
                      {item.tag}
                    </span>
                    {item.date && (
                      <span className="flex items-center gap-2 text-sm sm:text-base text-[#5B6877]">
                        <CalendarDays className="h-4 w-4" aria-hidden="true" />
                        {item.date}
                      </span>
                    )}
                  </div>
                  <h2 className="mt-4 font-serif text-xl sm:text-2xl lg:text-3xl font-medium text-[#101826]">
                    {item.title}
                  </h2>
                  {item.excerpt && (
                    <p className="mt-4 text-base sm:text-lg leading-relaxed text-[#3D4958]">
                      {item.excerpt}
                    </p>
                  )}
                </article>
              </Reveal>
            ))}
          </div>

          {NEWS.length === 0 && (
            <p data-testid="news-empty" className="mt-12 text-center text-lg text-[#5B6877]">
              No news just yet — please check back soon.
            </p>
          )}
        </div>
      </section>
    </>
  );
}
